import React from 'react'
import './About.css'
import ME from '../../assets/me-about.jpg'
import { FaAward } from 'react-icons/fa'
import { FaUsers } from 'react-icons/fa'
import { VscFolderLibrary } from 'react-icons/vsc'



const About = () => {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="About Imag" />
          </div>
        </div>


        <div className="about__content">
          <div className="about__cards">
            <article className='about__card '>
              <FaAward className='about__icon' />
              <h5>Experience</h5>
              <small>1 Year Work</small>
            </article>

            <article className='about__card '>
              <FaUsers className='about__icon' />
              <h5>Course</h5>
              <small>Programming Hero</small>
            </article>

            <article className='about__card '>
              <VscFolderLibrary className='about__icon' />
              <h5>Projects</h5>
              <small>15+ Completed</small>
            </article>
          </div>

          <p>
            Hello! I'm Md. Al Mamun Ridoy, a passionate web developer. I build responsive websites using this modern technology. I am a web developer with solid knowledge in different technologies and enough experience in creating and designing super responsive websites. I develop web applications and desktop applications. My core skill is based on JavaScript and I love to do most of the things using JavaScript. I love to make the web more open to the world. I Completed Web Development Course online from Programming-Hero. I am currently finish my HSC exam from Nimsar Junab Ali Collage. I am available for any kind of job opportunity that suits my interests.
          </p>

          <a href="#contact" className='btn btn-primary'>Let's Talk</a>

        </div>
      </div>
    </section>
  )
}

export default About